import axios from "axios";

function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded Unicode,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(
    encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode("0x" + p1);
      }
    )
  );
}

export const sendPostServices = async (payload) => {
  let data = { success: false, netWorkError: false };
  let tempPayload = payload;
  try {
    //console.log("payload", payload);
    // payload = JSON.stringify(payload);
    payload = b64EncodeUnicode(JSON.stringify(payload));
    const serviceResponse = await axios
      .post(process.env.REACT_APP_API_URL, payload, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      })
      .then((response) => response)
      .catch((error) => {
        console.log("error axios: ", error);
        // console.log("error: ", tempPayload);
      });
    //console.log("serviceResponse: ", payload.type, serviceResponse);
    if (serviceResponse.data) {
      data = { ...serviceResponse.data };
    }
  } catch (error) {
    //console.log("error sendPostServices:", error);
    data.netWorkError = true;
  }
  return data;
};
